
import { ofList } from "./fable_modules/fable-library-js.5.0.0/Map.js";
import { singleton, ofArray, map } from "./fable_modules/fable-library-js.5.0.0/List.js";
import { ServerErrorModule_text, ServerErrorModule_title } from "./StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { comparePrimitives } from "./fable_modules/fable-library-js.5.0.0/Util.js";
import { createElement } from "react";
import { BannerModule_View } from "./Components/StenaWebUI/Elements/Banner.js";
import { Cmd_ofEffect } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ToastModule_customToast } from "./Components/HotToast/Toast.js";
import { HeadingModule_View } from "./Components/StenaWebUI/Core/Heading.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0/Util.js";

export function ErrorView_serverErrorToast(e) {
    const p_1_1 = ofList(map((value) => value, ofArray([["variant", "error"], ["headerText", ServerErrorModule_title(e)], ["text", ServerErrorModule_text(e)]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    return createElement(BannerModule_View, {
        p: p_1_1,
    });
}

export function ErrorView_errorToast(e) {
    const p_1_1 = ofList(map((value) => value, ofArray([["variant", "error"], ["text", e]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    return createElement(BannerModule_View, {
        p: p_1_1,
    });
}

export function ErrorView_Cmd_ofError(e) {
    return Cmd_ofEffect((_arg) => {
        ToastModule_customToast(ofList(map((value_2) => value_2, singleton(["children", singleton(ErrorView_serverErrorToast(e))])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    });
}

export function ErrorView_Cmd_error(e) {
    return Cmd_ofEffect((_arg) => {
        ToastModule_customToast(ofList(map((value_2) => value_2, singleton(["children", singleton(ErrorView_errorToast(e))])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    });
}

export function PageTitle_titleWith(mkText, t, s) {
    let p_1_1, p_1_2;
    const children = ofArray([(p_1_1 = ofList(map((value) => value, ofArray([["variant", "h1"], ["children", singleton(mkText(t))]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(HeadingModule_View, {
        p: p_1_1,
    })), (p_1_2 = ofList(map((value_1) => value_1, ofArray([["variant", "h3"], ["children", singleton(mkText(s))]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), createElement(HeadingModule_View, {
        p: p_1_2,
    }))]);
    return createElement("div", defaultOf(), ...children);
}

export function PageTitle_title(t, s) {
    return PageTitle_titleWith((value) => value, t, s);
}

